module.exports = __webpack_public_path__ + "img/alabama-soil-water-logo.5dbdf5be.jpg";